/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Geo_ScoreInputs */

const en_directory_detail_signals_geo_score = /** @type {(inputs: Directory_Detail_Signals_Geo_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GEO-Score`)
};

const zh_directory_detail_signals_geo_score = /** @type {(inputs: Directory_Detail_Signals_Geo_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GEO-Score`)
};

/**
* | output |
* | --- |
* | "GEO-Score" |
*
* @param {Directory_Detail_Signals_Geo_ScoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_geo_score = /** @type {((inputs?: Directory_Detail_Signals_Geo_ScoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Geo_ScoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_geo_score(inputs)
	return zh_directory_detail_signals_geo_score(inputs)
});
export { directory_detail_signals_geo_score as "directory.detail.signals.geo_score" }